/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jan 19 2024
 **/

import { useQuery } from "@tanstack/react-query";

import { useUsers } from "@/frameworks/core/API";

export default function useNotificationConfig() {
	const userAPI = useUsers();
	const { data, isSuccess } = useQuery({
		queryKey: ["notification:inquiry"],
		queryFn: async () => {
			return (await userAPI.notification.inquiry.execute()).data;
		},
		refetchOnMount: false,
		refetchOnWindowFocus: false
	});
	return {
		data,
		isSuccess
	};
}
